import { get, put, post } from '../axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;

export function getFinancingStructure(documentId, siteId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/financingStructure`);
}

export function updateFinancingStructure(documentId, siteId, financingStructure) {
  return put(url + `/leasingoffers/${documentId}/${siteId}/financingStructure`, financingStructure);
}

export function computeOfferMaxResidualValuePercent(documentId, siteId, financingStructure) {
  return put(url + `/leasingoffers/${documentId}/${siteId}/financingStructure/residualvalue`, {
    documentId,
    siteId,
    financingStructure
  });
}

export function setFinancialProductIdOnSimulation(documentId, siteId, financialProductId) {
  return put(url + '/leasingoffers/product-id-on-simulation', { documentId, siteId, financialProductId });
}

export function getAvailableFinancialProducts(documentId, siteId, contractTypeId) {
  return post(url + '/leasingoffers/available-financial-products', { documentId, siteId, contractTypeId });
}

export function negotiateAmount(documentId, siteId, amounts) {
  return post(url + '/leasingoffers/negotiate-amount', { documentId, siteId, amounts });
}
